import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import SiteService from './SiteService';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

const SubMeterForm = ({ isUpdate }) => {
    const { mainMeterId, subMeterId } = useParams();
    const [kod, setKod] = useState('');
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [priority, setPriority] = useState('');
    const [nameError, setNameError] = useState(false);
    const [priorityError, setPriorityError] = useState(false);

    const [showInitialReadingModal, setShowInitialReadingModal] = useState(false);
    const [createdSubMeterId, setCreatedSubMeterId] = useState(null);

    const navigate = useNavigate();

    useEffect(() => {
        if (isUpdate && subMeterId) {
            SiteService.getSubMeterById(mainMeterId, subMeterId).then((res) => {
                const { kod, name, description, priority } = res.data;
                setKod(kod);
                setName(name);
                setDescription(description);
                setPriority(priority);
            });
        }
    }, [isUpdate, mainMeterId, subMeterId]);

    const saveOrUpdateSubMeter = (e) => {
        e.preventDefault();

        if (name.trim() === '') {
            setNameError(true);
        } else {
            setNameError(false);
        }

        if (!priority) {
            setPriorityError(true);
        } else {
            setPriorityError(false);
        }

        if (name.trim() === '' || !priority) {
            return;
        }

        const subMeter = { kod, name, description, priority };

        if (isUpdate) {
            SiteService.updateSubMeter(mainMeterId, subMeterId, subMeter).then(() => {
                navigate(`/sub-meters/${mainMeterId}`);
            });
        } else {
            SiteService.createSubMeter(mainMeterId, subMeter).then((res) => {
                const newId = res?.data?.subMeterId;
                setCreatedSubMeterId(newId);
                setShowInitialReadingModal(true);
            });
        }
    };

    const handleModalClose = (goToReading) => {
        setShowInitialReadingModal(false);
        if (goToReading && createdSubMeterId) {
            navigate(`/add-meter-reading/${mainMeterId}?subMeterId=${createdSubMeterId}`);
        } else {
            navigate(`/sub-meters/${mainMeterId}`);
        }
    };

    return (
        <div className="container">
            <div className="row">
                <div className="card col-md-6 offset-md-3 offset-md-3">
                    <h3 className="text-center">{isUpdate ? 'Süzme Sayaç Güncelle' : 'Süzme Sayaç Ekle'}</h3>
                    <div className="card-body">
                        <form>
                            <div style={{ margin: '10px' }}>
                                <TextField
                                    id="outlined-required"
                                    label="Kodu"
                                    value={kod}
                                    onChange={(e) => setKod(e.target.value)}
                                />
                            </div>
                            <div style={{ margin: '10px' }}>
                                <TextField
                                    required
                                    id="outlined-required"
                                    label="Süzme Sayaç Adı"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    error={nameError}
                                    helperText={nameError ? 'Bu alan boş bırakılamaz' : ''}
                                />
                            </div>
                            <div style={{ margin: '10px' }}>
                                <TextField
                                    id="outlined-required"
                                    label="Açıklama"
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                />
                            </div>
                            <div style={{ margin: '2px' }}>
                                <FormControl sx={{ m: 1, minWidth: 80 }}>
                                    <InputLabel id="priority-label">Öncelik</InputLabel>
                                    <Select
                                        labelId="priority-label"
                                        id="priority"
                                        value={priority}
                                        onChange={(e) => setPriority(e.target.value)}
                                        label="Öncelik"
                                        error={priorityError}
                                    >
                                        <MenuItem value={1}>İlk Tüketici</MenuItem>
                                        <MenuItem value={2}>İkinci Tüketici</MenuItem>
                                        <MenuItem value={3}>Son Tüketici</MenuItem>
                                    </Select>
                                    <FormHelperText>
                                        {priorityError ? 'Bu alan boş bırakılamaz' :
                                            'Kademeli tarifelerde tüketim arttıkça birim fiyat yükselir. Ucuz olan ilk kademeyi kullanma hakkı öncelik sırasına göre belirlenir.'}
                                    </FormHelperText>
                                </FormControl>
                            </div>

                            <button className="btn btn-success" onClick={saveOrUpdateSubMeter}>
                                {isUpdate ? 'Güncelle' : 'Kaydet'}
                            </button>
                            <button
                                className="btn btn-danger"
                                onClick={() => navigate(`/sub-meters/${mainMeterId}`)}
                                style={{ marginLeft: '10px' }}
                            >
                                İptal
                            </button>
                        </form>
                    </div>
                </div>
            </div>


            <Modal
                show={showInitialReadingModal}
                onHide={() => handleModalClose(false)}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Süzme Sayaç Başarıyla Tanımlandı</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Şimdi bu sayaç için ilk endeks değerlerini girmek ister misiniz?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => handleModalClose(false)}>
                        Hayır
                    </Button>
                    <Button variant="primary" onClick={() => handleModalClose(true)}>
                        Evet
                    </Button>
                </Modal.Footer>
            </Modal>

        </div>
    );
};

export default SubMeterForm;
